import React from 'react';
import { useLocation } from 'react-router-dom';


const Ended: React.FC = () => {
	const location = useLocation();

	let message = location.state.message;
	message = message.replace("SETTINGS.UPDATE_SUCCESS","正常終了");

  return (
    <div>
      ご登録ありがとうございます。別途、ご登録いただいたメールアドレスにてご連絡させていただきます。
      <p>{message}</p>
      <br/>
      <a href="https://secure.netvision.co.jp/new/recruit/fresh.html">新卒ページ</a><br/>
    </div>
  );
};

export default Ended;
